import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { useServerHealth } from "@/hooks/useMonitoring";
import { MonitoringServer } from "@/types/monitoring";

interface ServerHealthRowProps {
  server: MonitoringServer;
}

export const ServerHealthRow: React.FC<ServerHealthRowProps> = ({ server }) => {
  const { t } = useTranslation();
  const { data: health } = useServerHealth(server.id);

  const renderStatus = () => {
    if (!health) {
      return (
        <span className="text-xs text-muted-foreground">
          {t("common.loading")}
        </span>
      );
    }
    if (health.reachable) {
      return (
        <Badge variant="verified">{t("monitoring.servers.connected")}</Badge>
      );
    }
    return (
      <Badge variant="new_destructive">
        {t("monitoring.servers.unreachable")}
      </Badge>
    );
  };

  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-base-border bg-background px-4 py-3">
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="text-sm font-medium">{server.name}</span>
        <span className="truncate text-xs text-muted-foreground">
          {server.url}
        </span>
      </div>
      {renderStatus()}
    </div>
  );
};
